import { useApiClient } from "./useApiClient";
import { type ISelectObject } from "@/types/select";
import { type IHotelCategoryResponse } from "@/types/option";
import useSWRImmutable from "swr/immutable";

interface IUseHotelCategoryOptionsReturnType {
  hotelCategoryOptions: ISelectObject[];
}

export const useHotelCategoryOptions =
  (): IUseHotelCategoryOptionsReturnType => {
    const { apiClient } = useApiClient();

    // swrに引き渡すfetcher
    const fetcher = async (url: string): Promise<IHotelCategoryResponse> => {
      const { data } = await apiClient.get<IHotelCategoryResponse>(url);
      return data;
    };

    // IHotelCategoryResponseをISelectObject[]に変換する関数
    const toSelectObjectList = (
      data: IHotelCategoryResponse | undefined
    ): ISelectObject[] => {
      if (data === undefined) return [];

      return data.list.map((hotelCategory) => ({
        value: hotelCategory.id.toString(),
        label: hotelCategory.name,
      }));
    };

    const { data: hotelCategoryOptions } = useSWRImmutable(
      "/option/hotel-category",
      fetcher
    );

    return {
      hotelCategoryOptions: toSelectObjectList(hotelCategoryOptions),
    };
  };
